const { CATEGORIES, MAX_AGE, choices, readPreferences, savePreferences } = require('./preferences')
const { createTracking } = require('./tracking')

const clarityMeta = document.querySelector('meta[name="smmart-clarity-project"]')
let saved = readPreferences(document, Date.now())
let current = saved || choices(false)
let expiryTimer
const tracking = createTracking(window, document,
  () => readPreferences(document, Date.now()) || choices(false),
  clarityMeta ? clarityMeta.content : null,
  !!document.querySelector('meta[name="smmart-trial-conversion-owner"][content="gtm"]'))

function initialize() {
  const banner = document.getElementById('cookie-consent-banner')
  const overlay = document.getElementById('cookie-consent-preferences')
  if (!banner || !overlay) return
  const panel = overlay.querySelector('[role="dialog"]')
  const status = document.getElementById('cookie-consent-status')
  let returnFocus = null

  function updateExternalContent() {
    document.querySelectorAll('[data-consent-embed]').forEach(container => {
      const frame = container.querySelector('iframe')
      const placeholder = container.querySelector('[data-consent-placeholder]')
      if (current.external) {
        if (!frame.hasAttribute('src')) frame.setAttribute('src', frame.getAttribute('data-consent-src'))
      } else {
        // Replacing the frame destroys an already running third-party document.
        if (frame.hasAttribute('src')) {
          const replacement = frame.cloneNode(false)
          replacement.removeAttribute('src')
          frame.parentNode.replaceChild(replacement, frame)
        }
      }
      container.querySelector('iframe').hidden = !current.external
      placeholder.hidden = current.external
    })
  }

  function apply() {
    tracking.apply(current)
    updateExternalContent()
    banner.hidden = saved !== null
    window.clearTimeout(expiryTimer)
    if (saved && saved.savedAt) {
      // Browser timers are limited to a signed 32-bit delay.
      const remaining = saved.savedAt + MAX_AGE * 1000 - Date.now()
      expiryTimer = window.setTimeout(refresh, Math.min(Math.max(remaining, 1), 2147483647))
    }
  }

  function refresh() {
    saved = readPreferences(document, Date.now())
    current = saved || choices(false)
    apply()
  }

  function close() {
    overlay.hidden = true
    const target = returnFocus && document.contains(returnFocus) && !returnFocus.closest('[hidden]') ?
      returnFocus : document.querySelector('footer [data-consent-open]')
    if (target) target.focus({ preventScroll: true })
  }

  function open(trigger) {
    refresh()
    returnFocus = trigger
    CATEGORIES.forEach(category => {
      overlay.querySelector('[data-consent-category="' + category + '"]').checked = current[category]
    })
    overlay.hidden = false
    panel.focus()
  }

  function save(value) {
    saved = savePreferences(document, window.location, value, Date.now())
    current = saved
    apply()
    close()
    status.textContent = 'Vos préférences de cookies ont été enregistrées.'
    // Notify other tabs without storing analytics identifiers or duplicating choices.
    try {
      window.localStorage.setItem('smmart_consent_changed', String(Date.now()))
      window.localStorage.removeItem('smmart_consent_changed')
    } catch (error) { /* Storage can be disabled. */ }
  }

  document.addEventListener('click', function (event) {
    const target = event.target.closest ? event.target.closest('button') : null
    if (!target) return
    if (target.hasAttribute('data-consent-open')) open(target)
    if (target.hasAttribute('data-consent-close')) close()
    if (target.hasAttribute('data-consent-all')) save(choices(target.getAttribute('data-consent-all') === 'true'))
    if (target.hasAttribute('data-consent-save')) {
      const value = choices(false)
      CATEGORIES.forEach(category => {
        value[category] = overlay.querySelector('[data-consent-category="' + category + '"]').checked
      })
      save(value)
    }
  })

  overlay.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault()
      event.stopPropagation()
      close()
    }
    if (event.key === 'Tab') {
      const items = panel.querySelectorAll('button, a[href], input:not([disabled])')
      const first = items[0]
      const last = items[items.length - 1]
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel)) {
        event.preventDefault()
        first.focus()
      }
    }
  })
  // Keep the preferences usable even when opened above an existing Bootstrap modal.
  document.addEventListener('focusin', function (event) {
    if (overlay.hidden) return
    event.stopImmediatePropagation()
    if (!panel.contains(event.target)) panel.focus()
  }, true)

  window.addEventListener('pageshow', refresh)
  window.addEventListener('focus', refresh)
  window.addEventListener('storage', function (event) {
    if (event.key === 'smmart_consent_changed') refresh()
  })
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh()
  })

  if (saved && !saved.version) {
    // Migrate a legacy refusal once, without granting any optional category.
    saved = savePreferences(document, window.location, saved, Date.now())
    current = saved
  }
  apply()
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize)
else initialize()
